import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Button from '@material-ui/core/Button';
import { useSelector } from 'react-redux';
import Header from '../../../../../../../components/Stake/header';
import stylesParent from '../../../styles/frame/frame.module.scss';
import Tooltip from '../../../../../../../components/tooltip';
import { OM, LONG_CLAIM_PERIOD_AIRGRAB } from '../../../../../../../constants/blockchain-constants';
import stylesClaim from '../../../styles/claim/claim.module.scss';
import { formatToken } from '../../../../../../../helpers/token-helper';
import styled from 'styled-components';
import PolygonLogo from '../../../../../../../external/components/Icon/polygon';

const PolyLogo = styled(PolygonLogo)`
  width: 34px;
  height: 34px;
  margin-right: 0.25rem;
  margin-left: 0.25rem;
`;

const LongClaim = ({ setStatus }) => {
  const dark = useSelector((state) => state.basic.dark);
  const unclaimedAmount = useSelector((state) => state.delegator.matic.unclaimedAmount);

  return (
    <>
      <Header onClickBack={() => setStatus(2)} componentIcon={<PolyLogo />} title={`${OM}-Claim`} />
      <div className={stylesClaim.body}>
        <div className={stylesClaim.title}>Long Claim</div>
        <div className={stylesClaim.description}>
          You will be <span>receiving 100%</span> of the displayed OM Rewards.
        </div>
        <div className={stylesClaim.rows}>
          <div className={stylesClaim.rowContainer}>
            <div className={stylesClaim.row}>
              <div className={stylesClaim.rowLabel}>
                <Tooltip label={`Unclaimed ${OM} Rewards`} />
              </div>
              <div className={stylesClaim.rowValue}>{formatToken(unclaimedAmount)} OM</div>
            </div>
          </div>
          <div className={stylesClaim.rowContainer}>
            <div className={stylesClaim.row}>
              <div className={stylesClaim.rowLabel}>
                <Tooltip label='Available OM Rewards to Claim' />
              </div>
              <div className={stylesClaim.rowValue}>
                <b>{formatToken(unclaimedAmount)} OM</b>
              </div>
            </div>
            <div className={stylesClaim.row}>
              <div className={stylesClaim.rowLabel}>
                <Tooltip label='Claiming Period' />
              </div>
              <div className={stylesClaim.rowValue}>
                <b>{LONG_CLAIM_PERIOD_AIRGRAB} Days</b>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={cn(stylesParent.cardFooterControls, stylesParent.claim, {
          [stylesParent.dark]: dark,
        })}
      >
        <Button
          onClick={() => setStatus(9)}
          variant='contained'
          color='secondary'
          className={stylesParent.cardFooterControlsButton}
        >
          Next
        </Button>
      </div>
    </>
  );
};

LongClaim.propTypes = {
  setStatus: PropTypes.func.isRequired,
};

export default LongClaim;
